/**
 * These utilities are useful for determining where a function was called.
 * For example when you call logger.warn(''), logger will call console.warn('').
 * We want to make sure that all logs do not start with logger.ts:35
 */

export interface FileLocation {
    file?: string,
    line?: number,
    col?: number,
    func?: string
}

export const parseFileAndLocation = (file: string) => {
    const LINE_AND_COL_MATCH = /(?::(\d+))?(?::(\d+))?$/;
    const lineAndCol = file.match(LINE_AND_COL_MATCH)

    const fileAndLine: FileLocation = {
        file: lineAndCol ? file.substring(0, lineAndCol.index) : file
    }

    if (lineAndCol !== null) {
        const [line, col] = lineAndCol.slice(1);
        if (line) { fileAndLine.line = parseInt(line) }
        if (col) { fileAndLine.col = parseInt(col) }
    }
    return fileAndLine;
}

export const parseErrLine = (errLine: string) => {
    let fileLocation: FileLocation = {};
    const context = errLine
        .replace(/\s*at\s+/, '')
        .split(' ');

    const hasFile = context[context.length - 1].match(/\.(js|ts)x?(?::(\d+))?(?::(\d+))?/) !== null;
    if (hasFile) {
        let file = context.pop() as string;
        if (file.startsWith('(') && file.endsWith(')')) {
            file = file.slice(1, -1)
        }
        fileLocation = parseFileAndLocation(file);
    }
    fileLocation.func = context.join(' ');
    return fileLocation;
}

export const getLoggedStack = (stack: string): string => {
    const lines = stack.split('\n');
    let lastLoggerLine = 1;

    for (let i = 1; i < lines.length; i++) {
        const fileAndLine = parseErrLine(lines[i]);
        if (
            fileAndLine.file && (
                (fileAndLine.file as string).endsWith('DVWebNodeWidgetServer/server/applicationLogger.js') ||
                (fileAndLine.file as string).endsWith('DVWebNodeUtils/logger/logger.js')
            )
        ) {
            lastLoggerLine = i;
        }
    }

    lines.splice(1, lastLoggerLine);
    return lines.join('\n');
}

export const getLoggedLocation = (stack: string): FileLocation => {
    const loggedStack = getLoggedStack(stack);
    return parseErrLine(loggedStack.split('\n')[1]);
}
